export enum Sender {
  Assistant = "assistant",
  User = "user",
}
